import Vue from 'vue';
import TabPanel from 'primevue/tabpanel';

Vue.component('TabPanel', TabPanel);
